export default "__VITE_ASSET__d8e84a85__"